import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideApollo } from 'apollo-angular';

import { appRoutes } from './app.routes';

// Import modular configurations
import {
  createApolloConfig,
  oauthProviders,
  serviceProviders,
  sharedDomainProviders,
  stateHandlerProviders,
  uiProviders,
} from './config';

export const appConfig: ApplicationConfig = {
  providers: [
    // Core Angular providers
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withViewTransitions(), withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),

    // OAuth configuration
    ...oauthProviders,

    // Apollo GraphQL configuration
    provideApollo(createApolloConfig),

    // Service Worker configuration
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),

    // Custom service providers
    ...serviceProviders,

    // State handler providers
    ...stateHandlerProviders,

    // UI providers (PrimeNG)
    ...uiProviders,

    // Shared domain config
    ...sharedDomainProviders,
  ],
};
